import { Component, Input } from '@angular/core';
import { GridModel } from 'src/app/shared/model/page-grid';
import { CommonModule } from '@angular/common';
import { PageGridComponent } from 'src/app/shared/components/page-grid/page-grid.component';

@Component({
    selector: 'app-invoice-grid',
    templateUrl: './invoice-grid.component.html',
    imports: [
        CommonModule,
        PageGridComponent
    ]
})
export class InvoiceGridComponent {
  @Input() gridConfig!: GridModel<any>;
}
